/* jshint ignore:start */

'use strict';

(function (window, document, $) {

    if ($('.selma-prepaid').length === 0) {
        return false;
    }

    function validateForm() {
        if (!$('#sAmount').val()) {
            alert('Fältet Belopp får inte vara tomt.');
            $('#sAmount').focus();
            return false;
        }

        if (!$('#sOrderid').val()) {
            alert('Fältet Bokningsnummer får inte vara tomt.');
            $('#sOrderid').focus();
            return false;
        }

        if (!$('#sFirstname').val()) {
            alert('Fältet Förnamn får inte vara tomt.');
            $('#sFirstname').focus();
            return false;
        }

        if (!$('#sLastname').val()) {
            alert('Fältet Efternamn får inte vara tomt.');
            $('#sLastname').focus();
            return false;
        }

        if (!$('#sAdress').val()) {
            alert('Fältet Gatuadress får inte vara tomt.');
            $('#sAdress').focus();
            return false;
        }

        if (!$('#sPostal').val()) {
            alert('Fältet Postnummer får inte vara tomt.');
            $('#sPostal').focus();
            return false;
        }

        if (!$('#sCity').val()) {
            alert('Fältet Ort får inte vara tomt.');
            $('#sAmount').focus();
            return false;
        }

        if (!$('#sPhone').val()) {
            alert('Fältet Telefon får inte vara tomt.');
            $('#sPhone').focus();
            return false;
        }

        if (!$('#sEmail').val()) {
            alert('Fältet E-postadress får inte vara tomt.');
            $('#sEmail').focus();
            return false;
        }

        if (!isValidEmailAddress($('#sEmail').val())) {
            alert('E-postadress måste vara giltig.');
            $('#sEmail').focus();
            return false;
        }

        if (!$('#sPayment').is(':checked')) {
            alert('Vänligen välj en betalningsmetod.');
            $('#sPayment').focus();
            return false;
        }

        return true;
    }

    function isValidEmailAddress(emailAddress) {
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return pattern.test(emailAddress);
    };

    function renderData() {
        $('.s-amount-value').html($('#sAmount').val());
        $('.s-orderid-value').html($('#sOrderid').val());
        $('.s-firstname-value').html($('#sFirstname').val());
        $('.s-lastname-value').html($('#sLastname').val());
        $('.s-adress-value').html($('#sAdress').val());
        $('.s-postal-value').html($('#sPostal').val());
        $('.s-city-value').html($('#sCity').val());
        $('.s-phone-value').html($('#sPhone').val());
        $('.s-email-value').html($('#sEmail').val());
        $('.s-comment-value').html($('#sComment').val());
        $('.s-amount-value').html($('#sAmount').val());
    }

    function processData(md5key) {
        document.dibsForm.amount.value = $('#sAmount').val() * 100;
        document.dibsForm.billingAddress.value = $('#sAdress').val();
        document.dibsForm.billingFirstName.value = $('#sFirstname').val();
        document.dibsForm.billingLastName.value = $('#sLastname').val();
        document.dibsForm.billingPostalCode.value = $('#sPostal').val();
        document.dibsForm.billingPostalPlace.value = $('#sCity').val();
        document.dibsForm.email.value = $('#sEmail').val();
        document.dibsForm.md5key.value = md5key;
        document.dibsForm.orderid.value = $('#sOrderid').val();
    }

    $('.fn-first-step-btn').click(function(e) {
        if (validateForm() === true) {
            $('.selma-loader').show();
            $('.selma-prepaid__first').addClass('hidden');

            var parameter_string = '';
                parameter_string += 'merchant=90001832';
                parameter_string += '&orderid=' + $('#sOrderid').val();
                parameter_string += '&currency=752';
                parameter_string += '&amount=' + $('#sAmount').val() * 100;

            var data = {
                amount: $('#sAmount').val(),
                orderid: $('#sOrderid').val(),
                firstname: $('#sFirstname').val(),
                lastname: $('#sLastname').val(),
                adress: $('#sAdress').val(),
                postal: $('#sPostal').val(),
                city: $('#sCity').val(),
                phone: $('#sPhone').val(),
                email: $('#sEmail').val(),
                comment: $('#sComment').val()
            };

            $.ajax({
                type: 'post',
                url: selma_prepaid.ajaxurl,
                data: {
                    action: 'handle_prepaid',
                    data: parameter_string
                },
                success: function(response) {
                    createCookie('selma_prepaid_comment', $('#sComment').val(), 1);
                    renderData();
                    processData(response);
                    $('.selma-loader').hide();
                    $('.selma-prepaid__second').removeClass('hidden');
                }
            });
        }
    });

    $('.fn-back-fist-step-btn').click(function(e) {
        $('.selma-prepaid__second').addClass('hidden');
        $('.selma-prepaid__first').removeClass('hidden');
    });

})(window, document, jQuery);

function createCookie(name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}
